import Vue from 'vue'
import Vuelidate from 'vuelidate'

import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

import App from '@/App.vue'

import api from '@/api'
import config from '@/config'
import handleRequestError from '@/functions/handleRequestError'
import is from '@/functions/is'
import reset from '@/functions/reset'
import router from '@/router'
import sessionToken from '@/functions/sessionToken'
import store from '@/store'

// Settings
Vue.config.productionTip = false

// Add plugins
Vue.use(Vuelidate)

// Add global variables
Vue.prototype.$api = api
Vue.prototype.$config = config
Vue.prototype.$is = is

function initVue () {
  Sentry.init({
    Vue,
    dsn: config.sentry.dsn,
    tunnel: config.appUrl + config.sentry.tunnelEndpoint,
    integrations: [
      new Integrations.BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      })
    ],
    tracesSampleRate: config.sentry.sampleRate,
    environment: config.sentry.environment,
    release: config.sentry.release,
    logErrors: true
  })

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}

if (sessionToken.get()) {
  api.get('auth/user/')
    .then(response => {
      store.commit('user/data', response.data)
    })
    .catch(error => {
      // Don’t display error message on network error
      if (error.response) {
        handleRequestError({
          error,
          fallback: 'Bitte melden Sie sich mit Ihrem Konto erneut an.'
        })
      }

      if (error.response && error.response.data.code === 'unverified') {
        sessionToken.remove()
        reset.store()
      }
    })
    .finally(() => {
      initVue()
    })
} else {
  initVue()
}
